define('LNRS/Components/Content/Headers/CustomSectionHero',["jquery"], function ($) {

    function CustomSectionHero(scope, isInEditing, small, medium, large, smallBorder, mediumBorder) {
        if (isInEditing) {
            return;
        }

        if (small.length > 0) {
            var heroImage = $(scope).find('img');

            //in cases when section hero is in mantle stirpe image is shown only on mobile devices
            var parentStripe = $(heroImage).closest('.score-stripe');
            if (parentStripe) {
                if (parentStripe.hasClass('mantle-white-box-right') || parentStripe.hasClass('mantle-white-box-left') || parentStripe.hasClass('mantle-no-box-left') || parentStripe.hasClass('mantle-no-box-right')) {
                    var heroImageContainer = $(scope).find('div.score-hero-image');
                    if (!(heroImageContainer.height() > 0)) {
                        return;
                    }
                }
            }
            loadImage(heroImage, small, medium, large, smallBorder, mediumBorder);
        }
    }

    function loadImage(imgElement, small, medium, large, smallBorder, mediumBorder) {
        var screenWidth = $(window).width();
        if (screenWidth > mediumBorder) {
            $(imgElement).attr('src', large);
        }
        else if (screenWidth > smallBorder) {
            $(imgElement).attr('src', medium);
        }
        else {
            $(imgElement).attr('src', small);
        }
    }

    return function initCustomSectionHero(args) {
        return new CustomSectionHero(args.scope, args.IsInEditing, args.Small, args.Medium, args.Large, args.SmallBorder, args.MediumBorder);
    };
});
